import React, { memo } from 'react';
import { Col, Row } from 'components';
import { OfferInfo } from './OfferInfo';
import { PriceInfo } from './PriceInfo';
import { CardHeader } from './CardHeader';
import { ActionButtons } from './ActionButtons';
import { CommercialOfferModel } from 'models/CommercialOffer';
import { useCommercialOfferCard } from './useCommercialOfferCard';
import styles from './styles.module.scss';

export interface CommercialOfferCardProps {
  commercialOffer: CommercialOfferModel;
  onView?: (id: string) => void;
  onAction?: (action: string, id: string, uuid: string) => void;
  onCreateCopy?: (id: string) => void;
  onDelete: (id: string) => void;
}

export const CommercialOfferCard: React.FC<CommercialOfferCardProps> = memo((props) => {
  const { commercialOffer } = props;

  const {
    handleView,
    handleAction,
    handleCreateCopy,
    handleDelete,
    getStatusTagColor,
    getStatusDisplayText,
    displayDate,
    isRejected,
    isInFinalStatus,
  } = useCommercialOfferCard(props);

  const {
    offerNumber,
    status,
    createDate,
    lastModifiedDate,
    formattedCreateDate,
    formattedLastModifiedDate,
    itemsPrice,
    deliveryCost,
    additionalFees,
    total,
    validityDate,
    formattedValidityDate,
    leadTimeText,
    reason,
    additionalInformation,
    paymentTerms,
    negotiatePhase,
    negotiateInformation,
    uuid,
  } = commercialOffer;
  return (
    <div className={styles.card}>
      <CardHeader
        createDate={createDate}
        attachments={commercialOffer?.attachments}
        lastModifiedDate={lastModifiedDate}
        formattedCreateDate={formattedCreateDate}
        formattedLastModifiedDate={formattedLastModifiedDate}
        onCreateCopy={handleCreateCopy}
        onDelete={handleDelete}
        displayDate={displayDate}
        isInFinalStatus={isInFinalStatus}
      />

      <Row gutter={[8, 16]}>
        <Col span={12}>
          <OfferInfo
            offerNumber={offerNumber}
            status={status}
            uuid={uuid}
            reason={reason}
            negotiatePhase={negotiatePhase}
            additionalInformation={additionalInformation}
            negotiateInformation={negotiateInformation}
            getStatusTagColor={getStatusTagColor}
            getStatusDisplayText={getStatusDisplayText}
          />
        </Col>
        <Col span={12}>
          <PriceInfo
            itemsPrice={itemsPrice}
            deliveryCost={deliveryCost}
            additionalFees={additionalFees}
            total={total}
            validityDate={validityDate}
            formattedValidityDate={formattedValidityDate}
            leadTimeText={leadTimeText as string}
            displayDate={displayDate}
          />
          <ActionButtons
            isRejected={isRejected}
            status={status}
            paymentTerms={paymentTerms}
            onView={handleView}
            handleAction={handleAction}
            isInFinalStatus={isInFinalStatus}
          />
        </Col>
      </Row>
    </div>
  );
});
